import { useQuery } from '@tanstack/react-query';

import { apiRequest } from '../api/client';

export interface PortalMeSite {
  id: string;
  name: string;
}

export interface PortalMeOperatingUnit {
  id: string;
  name: string;
}

export interface PortalMeCustomer {
  id: string;
  tradeName: string;
}

export interface PortalMe {
  status: 'ACTIVE' | 'EXPIRED' | 'NONE';
  customer: PortalMeCustomer | null;
  sites: PortalMeSite[];
  /** Units of the customer's ACTIVE contracts; the selector shows only with more than one (`points-of-sale/design.md` T13). */
  operatingUnits: PortalMeOperatingUnit[];
  canOrder: boolean;
  dailyQuantityLimit: number | null;
}

/**
 * `GET /api/v1/portal/me` (added to close the gap flagged in PR 6's
 * `apply-progress.md`, Deviation #2): tells "never granted access"
 * (`status: 'NONE'`) apart from "access expired"
 * (`status: 'EXPIRED'`), unlike the earlier structural probe this
 * replaces, which could only detect an internal account hitting the
 * portal by mistake (a 404). Both `NONE` and `EXPIRED` mean "no active
 * access" for `ProtectedRoute`'s purposes; `AppShell`'s header uses
 * `customer`/`sites` when `status === 'ACTIVE'`.
 */
export function usePortalMe(enabled: boolean) {
  return useQuery<PortalMe>({
    queryKey: ['portal-me'],
    enabled,
    retry: false,
    queryFn: () => apiRequest<PortalMe>('/portal/me'),
  });
}
